import * as React from 'react';

interface ITooltipProps {
  className?: string;
  width?: string;
  secondary?: boolean;
  position?: 'top' | 'bottom';
  side?: 'center' | 'left' | 'right';
  disabled?: boolean;
  text: React.ReactNode;
}

export const Tooltip: React.FC<ITooltipProps> = ({
  children,
  className = '',
  width = '',
  secondary = false,
  position = 'bottom',
  side = 'center',
  disabled = false,
  text,
}) => (
  <div
    className={`inline-block ${disabled ? '' : 'group'} relative ${className}`}
  >
    {children}
    <span
      className={`tooltip tooltip--${position} tooltip--${side} absolute whitespace-no-wrap text-black text-center z-30 px-3 py-2 border shadow-md hidden group-hover:block ${
        secondary ? 'tooltip-secondary bg-grey' : 'bg-white'
      } ${width}`}
    >
      {text}
    </span>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Tooltip.tsx